<template>
    <Card
        :disabled="disabled"
        :cursorPointer="false"
        :hasPadArrow="true"
        :tagText="row?.memo"
        disabledShowArrow
        :arrowShow="true"
        arrowShowStyle="lg:hidden"
        class="sm:max-w-[30rem] mb-4 last:mb-0 md:mb-0"
    >
        <!-- @click="$emit('update:checkedRadio',row.cardNo)" -->
        <template #title>
            <div
                :class="[disabled?'cursor-auto':'cursor-pointer']"
                @click="disabled?'':$emit('update:checkedRadio',row?.cardNo)"
            >
                <Radio
                    v-if="!disabled"
                    v-model:checkedValue="policyRadio"
                    :value="row?.cardNo"
                    name="policy"
                    :text="row?.cardBankName"
                    radioType="2"
                    @click="$emit('update:checkedRadio',row?.cardNo)"
                />
                <span v-else>
                    {{ row?.cardBankName }}
                </span>
            </div>
        </template>
        <template #topContent>
            <div
                class="py-1.5 px-2.5 flex items-center justify-between"
                @click="disabled?'':$emit('update:checkedRadio',row?.cardNo)"
            >
                <div
                    class="text-base xs:text-lg text-right font-500"
                    :class="[disabled?'text-gray-200':' text-gray-900']"
                >
                    {{ row?.label }}
                </div>
            </div>
        </template>

        <template #foldContent>
            <!-- <template v-if="windowWidth>=767">
                <transition name="expand">
                    <CardContent
                        v-if="isOpen==='Y'"
                        :data="row.dataList"
                        :disabled="disabled"
                        @click="$emit('update:checkedRadio',row?.cardNo)"
                    />
                </transition>
            </template> -->
            <!-- <template v-else> -->
            <CardContent
                :data="row.dataList"
                :disabled="disabled"
                @click="$emit('update:checkedRadio',row?.cardNo)"
            />
            <!-- </template> -->
        </template>
        <!-- <template #bottomContent>
            <div
                class="py-1.5 px-2.5 grid grid-cols-1 hidden pad:grid cursor-pointer min-h-[2.6rem]"
                :style="{borderTopWidth:isOpen==='Y'?'1px':'0px'}"
                @click="switchOpen(isOpen)"
            >
                <div class="text-base text-center text-gray-600 flex items-center justify-end">
                    <span v-if="isOpen!=='Y'">查看保單資訊</span>
                    <span
                        v-else
                        class="pr-2"
                    >關閉</span>
                    <SvgIcon
                        v-if="isOpen!=='Y'"
                        icon-name="arrow_forward"
                        class="w-4 h-4 ml-1"
                    />
                </div>
            </div>
        </template> -->
    </Card>
</template>

<script>
import { ref, onMounted, toRef } from 'vue';
import Radio from '@/components/radios/Radio.vue';
import Card from '@/components/card/CardPolicyBase.vue';
import CardContent from './CardContent.vue';
import { useEventListener } from '@vueuse/core';

export default {
    components: {
        Card,
        Radio,
        CardContent
    },
    props: {
        checkedRadio: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        row: {
            type: Object,
            default: () => { }
        }
    },
    emits: ['update:checkedRadio'],
    setup(props) {
        const policyRadio = toRef(props, 'checkedRadio');
        const isOpen = ref('N');
        const windowWidth = ref(window.innerWidth);
        const switchOpen = (open) => {
            isOpen.value = open === 'Y' ? 'N' : 'Y';
        };
        onMounted(() => {
            useEventListener(window, 'resize', (evt) => {
                windowWidth.value = window.innerWidth;
            });
        });

        return {
            switchOpen,
            policyRadio,
            isOpen,
            windowWidth
        };
    },
};
</script>
<style lang="scss" scoped>
.expand-leave-active,
.expand-enter-active {
    transition: max-height 0.2s linear;
}
.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    overflow: hidden;
}

.expand-enter-to,
.expand-leave-from {
    max-height: 200px;
    overflow: hidden;
}
</style>
